import axiosInstance from '../lib/axios';
import type {
  DashboardStatsEnvelope,
  DashboardListEnvelope,
} from '../types/dashboard.types';

export const dashboardService = {
  async getStats() {
    const res = await axiosInstance.get<DashboardStatsEnvelope>(
      '/dashboard/stats'
    );
    return res.data;
  },
  async getLatestFiles() {
    const res = await axiosInstance.get<
      DashboardListEnvelope<{ documents: any[] }>
    >('/dashboard/latest-files?limit=3');
    return res.data;
  },
  async getFavorites() {
    const res = await axiosInstance.get<
      DashboardListEnvelope<{ favorites: any[] }>
    >('/dashboard/favorites?limit=3');
    return res.data;
  },
};

export default dashboardService;

